import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { LiabilitiesDashboard, LiabilityStatus } from '../../liabilities/models/model';
import { Liability, LiabilityGeneralInfo } from '../../liabilities/models/liability.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LiabilitiesApiService {
  constructor(private api: ApiService) {}

  public dashboard(): Observable<LiabilitiesDashboard> {
    return this.api.get<LiabilitiesDashboard>('/liabilities/dashboard', null, true, 'banner', ([data, socketFrame]) =>
      socketFrame ? { ...data, banner: socketFrame } : data,
    );
  }

  public firstLiabilities(): Observable<LiabilityGeneralInfo[]> {
    return this.api.get<Liability[]>('/liabilities/first')
      .pipe(map(liabilities => liabilities
        .map(value => {
          let statusEnum: LiabilityStatus = LiabilityStatus[value.newStatus as keyof typeof LiabilityStatus];
          if (statusEnum === null || statusEnum === undefined) {
            statusEnum = LiabilityStatus.UNKNOWN;
          }
          let newValue: LiabilityGeneralInfo = {
            amount: value.amount,
            amountToPay: value.amountToPay,
            id: value.id,
            billerName: value.billerName,
            paymentDue: value.paymentDue,
            tags: value.tags,
            tagsWithStyle: null,
            status: '',
            statusValue: statusEnum,
          };
          return newValue;
        })));
  }

  public existsUnpaidLiabilities(): Observable<Boolean> {
    return this.api.get<Boolean>('/liabilities/unpaid/exists');
  }

}
